export default "__VITE_ASSET__Diej3JaG__"